// extracted by mini-css-extract-plugin
module.exports = {"header":"AppBar_header__2hLq-"};